// types
import { ReportColumnDto } from 'src/api';
// constants
import { booleanAggregationModels } from '../constants/aggregation-model/boolean';

export function NewMembershipColumn(index: number) {
  const column = {
    field: 'newMembership',
    headerName: 'New Membership',
    description: 'Whether the membership is new or not',
    type: 'boolean',
    width: 150,
    index,
    groupable: true,
    filterable: true,
    availableAggregationFunctions: booleanAggregationModels,
    headerAlign: 'center',
    align: 'center',
  } as ReportColumnDto<any, any, any>;
  return column;
}
